var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "knit logo 2 4",
    clipPath: "url(#clip0_818_9428)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.726 68.1295H19.2945C14.1773 68.1295 9.26964 66.1075 5.65122 62.5084C2.03281 58.9094 0 54.028 0 48.9381V0H6.43149C11.5487 0 16.4563 2.02194 20.0747 5.62103C23.6931 9.22011 25.726 14.1015 25.726 19.1914V68.1295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M97.4113 94.4602L94.1955 100L44.0556 71.213C43.0386 70.6298 42.0774 69.9553 41.184 69.1979C38.1803 66.9805 35.7401 64.0945 34.0589 60.7709C32.3776 57.4472 31.502 53.7783 31.502 50.0577C31.502 46.337 32.3776 42.6681 34.0589 39.3445C35.7401 36.0208 38.1803 33.1348 41.184 30.9174C42.0774 30.16 43.0386 29.4855 44.0556 28.9023L94.1827 0.115234L97.3984 5.65515C98.6667 7.83901 99.4898 10.2501 99.8207 12.7506C100.152 15.2511 99.9836 17.7919 99.3266 20.2278C98.6696 22.6637 97.5363 24.9469 95.9915 26.9469C94.4467 28.9468 92.5208 30.6243 90.3238 31.8834L76.9527 39.56L58.6551 50.0673L76.9527 60.5746L90.3238 68.2511C94.7578 70.7918 97.9956 74.9805 99.3247 79.8956C100.654 84.8108 99.9656 90.0498 97.4113 94.4602Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_818_9428"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.eeb51014500b56c1f85b72cc754a7032.svg";
export { ForwardRef as ReactComponent };